import React from 'react';
import { renderToString } from 'react-dom/server';
import i18n from 'i18next';
import {
  getFileDescription,
  getFileExtensionDescription,
  DownloadByteUnit,
} from '../../../../../../../_lib/components/Download';
import { DownloadAbbr } from '../../../../../../../_lib/components/Download/partials/DownloadAbbr';

export function linkChooserFileLink(anchorContent, fileExtension, linkAttributes) {
  return renderToString(
    <a
      className="download__link download__link--no-margin download__link--no-padding"
      href={linkAttributes.href}
      // keep this download to store file extension information later needed in WYSIWYG to show additional
      // information about the file to the user. download attribute will then be stripped at rendering in WYSIWYG.
      download={linkAttributes.download}
      type={linkAttributes.type}
      rel={linkAttributes.rel}
      target={linkAttributes.target}
      data-resource-reference={linkAttributes['data-resource-reference']}
      data-anchor={linkAttributes['data-anchor']}
      data-link-type={linkAttributes['data-link-type']}
      data-file-size={linkAttributes['data-file-size']}
      title={getFileDescription(fileExtension)}
    >
      {linkChooserFileLinkContent(anchorContent, fileExtension, linkAttributes['data-file-size'])}
    </a>,
  );
}

export function linkChooserFileLinkContentAsString(anchorContent, fileExtension, fileSize) {
  return renderToString(linkChooserFileLinkContent(anchorContent, fileExtension, fileSize));
}

function linkChooserFileLinkContent(anchorContent, fileExtension, fileSize) {
  if (i18n.isInitialized && fileExtension) {
    return (
      <span className="download__file-title">
        {anchorContent} (
        <DownloadAbbr text={fileExtension.toUpperCase()} title={getFileExtensionDescription(fileExtension)} />
        , <DownloadByteUnit bytes={parseInt(fileSize, 10)} />)
      </span>
    );
  }

  return <span className="download__file-title">{anchorContent}</span>;
}
